import * as Types from '../../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FulfillInventoryMoveRequestPageQueryVariables = Types.Exact<{
  input: Types.InventoryMoveRequestInput;
  lotsInput: Types.InventoryMoveRequestSkusAvailableLotsInput;
}>;


export type FulfillInventoryMoveRequestPageQuery = { readonly __typename?: 'Query', readonly inventoryMoveRequest: { readonly __typename?: 'InventoryMoveRequest', readonly id: string, readonly createdAt: string, readonly requestor: { readonly __typename?: 'User', readonly person?: { readonly __typename?: 'UserPerson', readonly firstname?: string | null, readonly lastname?: string | null } | null }, readonly receivingLocation: { readonly __typename?: 'Location', readonly name: string }, readonly skus: { readonly __typename?: 'InventoryMoveRequestSkuPaged', readonly items: ReadonlyArray<{ readonly __typename?: 'InventoryMoveRequestSku', readonly id: string, readonly quantityRequested: number, readonly sku: { readonly __typename?: 'Sku', readonly id: string, readonly name: string, readonly externalReferences: ReadonlyArray<{ readonly __typename?: 'SkuExternalReference', readonly origin: string }> }, readonly availableLots: ReadonlyArray<{ readonly __typename?: 'Lot', readonly id: string, readonly quantity: number, readonly expiryDate: string }> }> } } };


export const FulfillInventoryMoveRequestPageDocument = gql`
    query fulfillInventoryMoveRequestPage($input: InventoryMoveRequestInput!, $lotsInput: InventoryMoveRequestSkusAvailableLotsInput!) {
  inventoryMoveRequest(input: $input) {
    id
    createdAt
    requestor {
      person {
        firstname
        lastname
      }
    }
    receivingLocation {
      name
    }
    skus {
      items {
        id
        quantityRequested
        sku {
          id
          name
          externalReferences {
            origin
          }
        }
        availableLots(input: $lotsInput) {
          id
          quantity
          expiryDate
        }
      }
    }
  }
}
    `;

/**
 * __useFulfillInventoryMoveRequestPageQuery__
 *
 * To run a query within a React component, call `useFulfillInventoryMoveRequestPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFulfillInventoryMoveRequestPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFulfillInventoryMoveRequestPageQuery({
 *   variables: {
 *      input: // value for 'input'
 *      lotsInput: // value for 'lotsInput'
 *   },
 * });
 */
export function useFulfillInventoryMoveRequestPageQuery(baseOptions: Apollo.QueryHookOptions<FulfillInventoryMoveRequestPageQuery, FulfillInventoryMoveRequestPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FulfillInventoryMoveRequestPageQuery, FulfillInventoryMoveRequestPageQueryVariables>(FulfillInventoryMoveRequestPageDocument, options);
      }
export function useFulfillInventoryMoveRequestPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FulfillInventoryMoveRequestPageQuery, FulfillInventoryMoveRequestPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FulfillInventoryMoveRequestPageQuery, FulfillInventoryMoveRequestPageQueryVariables>(FulfillInventoryMoveRequestPageDocument, options);
        }
export type FulfillInventoryMoveRequestPageQueryHookResult = ReturnType<typeof useFulfillInventoryMoveRequestPageQuery>;
export type FulfillInventoryMoveRequestPageLazyQueryHookResult = ReturnType<typeof useFulfillInventoryMoveRequestPageLazyQuery>;
export type FulfillInventoryMoveRequestPageQueryResult = Apollo.QueryResult<FulfillInventoryMoveRequestPageQuery, FulfillInventoryMoveRequestPageQueryVariables>;